module.exports = __webpack_public_path__ + "img/google-petra-01.4f812ec8.jpg";